export default {
  'site.name': 'AllChinaBuy Spreadsheet',
  'site.tagline': 'Ihr Intelligenter Weg, AllChinaBuy zu Entdecken',
  'site.description': 'Erkunden Sie das AllChinaBuy-Spreadsheet mit Produktlisten, Verkäuferhandbüchern, QC-Tipps, Versandinformationen, Bewertungen und Kaufressourcen.',
  'nav.home': 'Startseite',
  'nav.spreadsheet': 'Spreadsheet',
  'nav.guides': 'Handbücher',
  'nav.products': 'Produkte',
  'nav.sellers': 'Verkäufer',
  'nav.shipping': 'Versand',
  'nav.qc': 'QC',
  'nav.review': 'Bewertung',
  'nav.safety': 'Sicherheit',
  'nav.articles': 'Artikel',
  'nav.language': 'Sprache',
  'nav.mainSite': 'Hauptseite',
  'nav.shoppingGuide': 'Kaufberatung',
  'hero.title': 'AllChinaBuy Spreadsheet: Produkte, Verkäufer & Kaufhandbücher Finden',
  'hero.subtitle': 'Entdecken Sie organisierte AllChinaBuy-Spreadsheet-Ressourcen, Produkthandbücher, Verkäuferinformationen, QC-Tipps, Versandhandbücher und praktische Kaufberatung an einem Ort.',
  'hero.cta.explore': 'AllChinaBuy Spreadsheet Erkunden',
  'hero.cta.guides': 'Kaufhandbücher Durchsuchen',
  'hero.cta.mainSite': 'Hauptseite Besuchen',
  'hero.search.placeholder': 'Suche nach Spreadsheet, Produkten, Verkäufern oder Handbüchern...',
  'categories.title': 'Beliebte Kategorien',
  'categories.subtitle': 'Durchsuchen Sie unsere kuratierten Produktkategorien aus dem AllChinaBuy-Spreadsheet',
  'categories.all': 'Alle Kategorien',
  'features.title': 'Warum AllChinaBuy Spreadsheet Nutzen',
  'features.organized': 'Organisierte Produkte',
  'features.organized.desc': 'Alle Produkte übersichtlich kategorisiert und durchsuchbar für einfache Entdeckung.',
  'features.sellers': 'Verifizierte Verkäufer',
  'features.sellers.desc': 'Finden Sie zuverlässige Verkäufer mit Bewertungen und Produktqualitätsinformationen.',
  'features.qc': 'QC-Anleitung',
  'features.qc.desc': 'Lernen Sie Qualitätskontrolltipps, um sicherzustellen, dass Sie genau das erhalten, was Sie bestellt haben.',
  'features.shipping': 'Versandinformationen',
  'features.shipping.desc': 'Vergleichen Sie Versandmethoden, Kosten und Lieferzeiten in Ihr Land.',
  'articles.title': 'Neueste Handbücher & Artikel',
  'articles.subtitle': 'Detaillierte Ressourcen, um Ihnen zu helfen, intelligenter auf AllChinaBuy einzukaufen',
  'articles.readMore': 'Mehr Lesen',
  'articles.allArticles': 'Alle Artikel Ansehen',
  'products.title': 'Empfohlene Produkte',
  'products.subtitle': 'Durchsuchen Sie kuratierte Produkte aus dem AllChinaBuy-Spreadsheet. Klicken Sie auf ein Element, um zur Produktseite zu springen und Ihren Kauf abzuschließen.',
  'products.viewAll': 'Alle Ansehen',
  'products.buy': 'Kaufen',
  'products.viewFull': 'Vollständiges Spreadsheet Ansehen',
  'products.wantMore': 'Möchten Sie mehr Produkte sehen?',
  'products.moreDesc': 'Erkunden Sie das vollständige AllChinaBuy-Spreadsheet mit 10.000+ verifizierten Produkten in allen Kategorien.',
  'products.visitFull': 'Vollständiges Spreadsheet Besuchen',
  'cta.title': 'Bereit Zum Einkaufen?',
  'cta.subtitle': 'Besuchen Sie unsere Hauptseite, um das vollständige AllChinaBuy-Spreadsheet zu durchsuchen und Ihre Einkaufsreise zu beginnen.',
  'cta.button.main': 'AllChinaBuy Spreadsheet',
  'cta.button.buy': 'Jetzt Kaufen',
  'footer.about': 'Über Uns',
  'footer.contact': 'Kontakt',
  'footer.privacy': 'Datenschutzrichtlinie',
  'footer.terms': 'Nutzungsbedingungen',
  'footer.disclaimer': 'Haftungsausschluss',
  'footer.editorial': 'Redaktionelle Richtlinie',
  'footer.copyright': 'AllChinaBuy Spreadsheet. Unabhängige Ressourcen-Hub. Nicht verbunden mit AllChinaBuy.',
  'footer.disclaimerText': 'Diese Website ist eine unabhängige Informationsressource und ist nicht mit AllChinaBuy verbunden oder offiziell von AllChinaBuy anerkannt, es sei denn, dies wird ausdrücklich angegeben.',
  'lang.en': 'Englisch',
  'lang.fr': 'Französisch',
  'lang.da': 'Dänisch',
  'lang.de': 'Deutsch',
  'seo.homeTitle': 'AllChinaBuy Spreadsheet – Produkte, Verkäufer & Kaufhandbücher',
  'seo.homeDescription': 'Erkunden Sie das AllChinaBuy-Spreadsheet mit Produktlisten, Verkäuferhandbüchern, QC-Tipps, Versandinformationen, Bewertungen und Kaufressourcen.',
};